import { useEffect } from 'react';
import { useSelector } from 'react-redux';
// @ts-ignore no types
import { PREVIEW_EDITOR } from 'feedback-schema/constants/messageChannels';
// @ts-ignore no types
import { READY, STAGE_CHANGE } from 'feedback-schema/constants/messageTypes';
// @ts-ignore no types
import { parentListener } from 'feedback-utils/subscriptions/messages';
// @ts-ignore no types
import { parentSender } from 'feedback-utils/messages';
import { useSubmissionUpdates } from 'feedback-public-submission-ui/hooks/useSubmissionUpdates';
import { useDeviceSizeChange } from 'feedback-public-submission-ui/hooks/useDeviceSizeChange';
import SurveyContents from 'feedback-public-submission-ui/containers/SurveyContents';
import { getFeedbackResponseSelector } from 'feedback-public-submission-ui/selectors';
import { areParamsValid } from 'feedback-public-submission-ui/utils/areParamsValid';
import { parse } from 'feedback-public-submission-ui/utils/parse';
import { useSurveyConfig } from 'feedback-public-submission-ui/hooks/useSurveyConfig';
import { jsx as _jsx } from "react/jsx-runtime";
const sendToParent = parentSender(PREVIEW_EDITOR);
const changeStage = (stage, rating) => {
  sendToParent(STAGE_CHANGE, {
    stage,
    rating
  });
};
const Preview = ({
  params,
  surveyType
}) => {
  const {
    fetchSurvey,
    updatePreview
  } = useSurveyConfig();
  const feedbackResponse = useSelector(getFeedbackResponseSelector);
  const {
    device
  } = useDeviceSizeChange();
  const {
    handleInterframeMessage,
    setSelectedRating
  } = useSubmissionUpdates();
  useEffect(() => {
    parentListener(PREVIEW_EDITOR)(handleInterframeMessage(updatePreview));
    sendToParent(READY);
    if (areParamsValid(params)) {
      setSelectedRating(parse(params.rating));
      fetchSurvey(params, surveyType);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_jsx(SurveyContents, {
    changeStage: changeStage,
    device: device,
    feedbackResponse: feedbackResponse,
    params: params,
    surveyType: surveyType
  });
};
export default Preview;